import { Component, ViewChild } from '@angular/core';
import { NgxSmartModalComponent } from 'ngx-smart-modal';
import { Utility } from 'src/app/core/common';
import { AccountingService } from 'src/app/services/accounting.service';
import { SharedService } from 'src/app/services/shared.service';

@Component({
  selector: 'app-accounting',
  templateUrl: './accounting.component.html',
  styleUrls: ['./accounting.component.scss']
})
export class AccountingComponent {
  records: any[] = [];
  accounts: any[];
  payments: any[];
  extraPayments: any[] = [];
  personel: any[];
  balance: { hesabfa: { Balance: number, Code: string, Name: string }[], bank: { [key: string]: number } };
  bankCodes = {
    mellat: '0001',
    saman: '0002',
    '0001': 'mellat',
    '0002': 'saman',
  };
  constructor(private accountingService: AccountingService, private sharedService: SharedService) { }

  beneficiaries: any[];
  shortcuts = [
    {
      show: record => record.Amount > 0,
      title: 'واریز نامشخص',
      account: 'دارایی ها : دارایی های جاری : سایر حساب های دریافتنی : سایر حساب های دریافتنی'
    },
    {
      show: record => record.Amount < 0,
      title: 'برداشت نامشخص',
      account: 'دارایی ها : دارایی های جاری : سایر حساب های دریافتنی : سایر حساب های دریافتنی'
    },
    {
      show: record => record.Amount < 0,
      title: 'کارمزد بانکی',
      account: 'هزینه ها : هزینه های غیرعملیاتی : هزینه های بانکی : کارمزد خدمات بانکی'
    },
    {
      show: record => record.Amount < 0,
      title: 'حقوق و دستمزد پرداختنی',
      account: 'بدهی ها : بدهیهای جاری : سایر حساب های پرداختنی : حقوق و دستمزد پرداختنی'
    },
    {
      show: record => record.Amount > 0,
      title: 'درآمد',
      account: 'درآمد : درآمد های غیر عملیاتی : سایر درآمد ها'
    },
    {
      title: 'جاری شرکا',
      account: 'بدهی ها : بدهیهای جاری : جاری شرکا',
      fee: amount => amount < 0 ? 360 : 0
    },
  ]

  async ngOnInit() {
    setTimeout(async () => {
      this.personel = await this.accountingService.contacts({
        queryInfo: {
          //Filters: [{ Property: 'Category.Name', Operator: '=', Value: 'کارمند' }]
          Take: 1000
        }
      });
      this.accounts = await this.accountingService.accounts();
      this.beneficiaries = await this.accountingService.beneficiaries();
    });

    this.load();
  }

  async upload(file: any) {
    await this.accountingService.uploadMellatRecords(file);
  }

  limit: number = 50;
  total: number;
  isRegistered = false;

  reload(autoVerify = false) {
    this.records = [];
    setTimeout(async () => await this.load(autoVerify));
  }

  async load(autoVerify = false) {
    if (autoVerify) {
      this.isRegistered = false;
      this.records = [];
    }
    await this.search(0, autoVerify);

    if (!this.isRegistered && this.records.length)
      await this.match();

    this.balance = await this.accountingService.getBalance();
  }

  async search(from: number, autoVerify = false) {
    var result = await this.accountingService.list(autoVerify, this.isRegistered, from, this.limit);
    if (result?.records?.length)
      this.records.push(...result.records);
    this.total = result?.total;
  }

  async loadMore() {
    await this.search(this.records.length);
  }

  async lock() {
    await this.accountingService.lock();
    this.records = [];
    this.reload();
  }

  async setAccount(shortcut: any) {
    this.records[0].PaymentIds = [];
    this.records[0].ExtraPayments = [];
    this.select(false);
    this.records[0].Title = shortcut.title || null;
    this.records[0].Account = this.accounts.find(_ => _.FullPath == shortcut.account);
    this.records[0].Fee = shortcut.fee ? shortcut.fee(this.records[0].Amount) : undefined;
  }

  async setBeneficiary(beneficiary: any) {
    this.records[0].Beneficiary = beneficiary;
    this.records[0].PaymentIds = [];
    this.records[0].ExtraPayments = [];
    this.select(false);
    this.records[0].Title = beneficiary.Name || null;
    this.records[0].Account = this.accounts?.find(_ => _.FullPath == beneficiary.AccountPath);
    this.records[0].Fee = beneficiary.Fee;
  }

  async verify() {
    this.records[0].BatchIds = [this.records[0].Id, ...this.records.filter(_ => _._selected).map(_ => _.Id)];
    this.records[0].PaymentIds = this.payments?.filter(_ => _.Id && _._selected).map(_ => _.Id) || [];
    this.records[0].ExtraPayments = this.extraPayments?.filter(_ => _._selected) || [];
    this.records[0] = await this.accountingService.verify(this.records[0]);
    this.reload(true);
  }
  async unverify(recordId: string, force = false) {
    await this.accountingService.unverify(recordId, force);
    this.reload();
  }

  get sum() {
    return (
      (Utility.sum(this.extraPayments?.filter(_ => _._selected), 'Amount') || 0) +
      (Utility.sum(this.payments?.filter(_ => _._selected), 'Amount') || 0)
    ) * 10;
  }
  get paymentSelected() { return this.payments?.some(_ => _._selected) || this.extraPayments?.some(_ => _._selected) || false; }

  offset = 0;
  async match(addOffset = false) {
    if (addOffset) this.offset++;
    else this.offset = 0;

    delete this.payments;
    if (!this.records.length) return;
    const record = this.records[0];

    var match = await this.accountingService.match(record.Id, this.offset);
    record.PaymentIds = match.matched;
    this.payments = match.payments;
    record._balanced = match.balanced;

    this.payments?.forEach(_ => { _._selected = record.PaymentIds?.includes(_.Id); });
    this.sharedService.scrollIntoView(`[record-id='${record.Id}']`, 'start');

    if (record.Beneficiary)
      this.records[0].Account = this.accounts?.find(_ => _.FullPath == record.Beneficiary.AccountPath);

    this.sharedService.badge(match.balanced ? null : 'X', { bgColor: '#FF0000' });
    // if (match.balanced) await this.verify();
  }

  extraPayment: any;
  @ViewChild('ExtraPaymentModal') ExtraPaymentModal: NgxSmartModalComponent;
  addExtraPayment(record: any) {
    this.extraPayment = Utility.clone({
      _selected: true,
      Amount: (record.BeneficiaryAmount - this.sum) / 10,
      Description: 'آگهی لوکوپوک'
    });
    this.ExtraPaymentModal.open();
  }

  select(select?: boolean) {
    var checked = select != undefined ? select : !this.paymentSelected;
    this.payments?.forEach(_ => _._selected = checked);
  }

  async update(recordId: string) {
    await this.accountingService.update(recordId);
  }
}
